import {Directive, EventEmitter, HostBinding, HostListener, Input, Output} from "@angular/core";
import {FUIOptionsService} from "./options.service";

@Directive()
export abstract class FUIAbstractOption {
    @Input() public field: string;
    @Input() public key: string;
    @Input() public option: any;
    @Input() public clearSelectionOptionLabel: string;
    @Input() public optionOpenable: boolean;
    @Output() public optionOpened$: EventEmitter<any>;
    @HostBinding("attr.tabindex") public tabindex: number;
    @HostBinding("class.valued") protected _valued: boolean;

    constructor(protected optionsService: FUIOptionsService) {
        this.optionOpened$ = new EventEmitter<any>();
    }

    /**
     * Return the label or the whole selection
     * @param option
     * @returns {string}
     */
    public label(option: any): string {
        if (this.option == undefined) {
            return this.clearSelectionOptionLabel;
        } else {
            if (this.key) {
                return this.option[this.key];
            }

            return this.option;
        }
    }

    openOption(event: Event) {
        this.optionOpened$.next(this.option);
    }

    @HostListener("contextmenu", ["$event"]) onContextMenu(event: Event): void {
        event.stopPropagation();
        event.preventDefault();
    }
}
